<div class="code-ai-modal" *ngIf="isOpen" [class.closing]="isClosing" (click)="closeModal()">
  <div class="code-ai-modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="code-ai-header">
      <div class="header-title">
        <i class="fas {{ getIcon() }}"></i>
        <h3>{{ getTitle() }}</h3>
      </div>
      <button class="close-btn" (click)="closeModal()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isGenerating">
      <div class="spinner-container">
        <i class="fas fa-spinner fa-spin fa-3x"></i>
        <p class="loading-text">Generating {{ type === 'css' ? 'CSS' : 'JavaScript' }}...</p>
      </div>
    </div>

    <!-- Body -->
    <div class="code-ai-body">
      <!-- Error/Warning Alert -->
      <div class="alert" *ngIf="error" [ngClass]="{
             'alert-danger': errorType === 'error',
             'alert-warning': errorType === 'warning',
             'alert-info': errorType === 'info'
           }">
        <i class="fas" [ngClass]="{
             'fa-exclamation-triangle': errorType === 'error',
             'fa-exclamation-circle': errorType === 'warning',
             'fa-info-circle': errorType === 'info'
           }"></i>
        {{ error }}
      </div>

      <!-- Informative Message (when editing existing code) -->
      <div class="edit-info-message" *ngIf="hasExistingCode()">
        <i class="fas fa-info-circle"></i>
        <span>AI will modify your existing {{ type === 'css' ? 'CSS' : 'JavaScript' }} code</span>
      </div>

      <!-- Current Code Section (Read-only) -->
      <div class="current-code-section" *ngIf="hasExistingCode()">
        <div class="section-header">
          <label class="section-label">
            <i class="fas fa-file-code"></i>
            Current {{ type === 'css' ? 'CSS' : 'JavaScript' }} Code
          </label>
          <button class="btn-toggle-code" (click)="showCurrentCode = !showCurrentCode">
            <i class="fas" [ngClass]="showCurrentCode ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ showCurrentCode ? 'Hide' : 'Show' }}</span>
          </button>
        </div>
        <div class="code-display" *ngIf="showCurrentCode">
          <pre class="code-readonly"><code>{{ existingCode }}</code></pre>
        </div>
      </div>

      <!-- Prompt Section (MOVED BEFORE Quick Actions) -->
      <div class="prompt-section">
        <div class="prompt-header">
          <label class="prompt-label">
            <i class="fas fa-comment-dots"></i>
            {{ hasExistingCode() ? 'Describe what you want to change:' : 'Describe what you want to generate:' }}
          </label>
          <button class="btn-undo" *ngIf="canUndo()" (click)="undo()" [disabled]="isGenerating"
            title="Undo last change">
            <i class="fas fa-undo"></i>
            <span>Undo</span>
          </button>
        </div>
        <textarea class="prompt-textarea" [(ngModel)]="userPrompt" [placeholder]="getPlaceholderText()" rows="4"
          [disabled]="isGenerating">
        </textarea>
        <button class="btn-generate" (click)="generateCode()" [disabled]="!userPrompt.trim() || isGenerating"
          title="Generate code">
          <i class="fas fa-paper-plane"></i>
        </button>
      </div>

      <!-- Quick Actions (MOVED AFTER Prompt) -->
      <div class="quick-actions-section" *ngIf="hasExistingCode()">
        <label class="section-label">
          <i class="fas fa-bolt"></i>
          Quick Actions
        </label>
        <div class="quick-actions-grid">
          <button *ngFor="let action of quickActions" class="quick-action-btn" (click)="addQuickAction(action.prompt)"
            [disabled]="isGenerating">
            <i class="fas {{ action.icon }} quick-action-icon"></i>
            <span class="quick-action-label">{{ action.label }}</span>
          </button>
        </div>
      </div>

      <!-- Presets Section (only when NO existing code) -->
      <div class="presets-section" *ngIf="!hasExistingCode()">
        <div class="presets-header">
          <label class="presets-label">
            <i class="fas fa-bolt"></i>
            Quick Start Templates:
          </label>

          <!-- Category Filter -->
          <div class="category-filter">
            <button *ngFor="let category of categories" class="category-btn"
              [class.active]="selectedCategory === category" (click)="filterByCategory(category)">
              {{ category }}
            </button>
          </div>
        </div>

        <div class="presets-grid">
          <div *ngFor="let preset of filteredPresets" class="preset-card" (click)="selectPreset(preset)">
            <i class="fas {{ preset.icon }} preset-icon"></i>
            <span class="preset-label">{{ preset.label }}</span>
          </div>
        </div>
      </div>

      <!-- Preview Section -->
      <div class="preview-section" *ngIf="showPreview && generatedCode">
        <div class="preview-header">
          <label class="preview-label">
            <i class="fas fa-code"></i>
            {{ hasExistingCode() ? 'Modified' : 'Generated' }} {{ type === 'css' ? 'CSS' : 'JavaScript' }}
          </label>
          <button class="btn-copy" (click)="copyToClipboard()" [class.copied]="copySuccess" title="Copy to clipboard">
            <i class="fas" [ngClass]="copySuccess ? 'fa-check' : 'fa-copy'"></i>
            <span>{{ copySuccess ? 'Copied!' : 'Copy' }}</span>
          </button>
        </div>

        <!-- Explanation -->
        <div class="code-explanation" *ngIf="explanation">
          <i class="fas fa-lightbulb"></i>
          <p>{{ explanation }}</p>
        </div>

        <!-- Code Preview -->
        <pre class="code-preview"><code>{{ generatedCode }}</code></pre>

        <!-- Action Buttons -->
        <div class="preview-actions">
          <button class="btn btn-secondary" (click)="showPreview = false">
            <i class="fas fa-times"></i>
            <span>Cancel</span>
          </button>
          <button class="btn btn-primary" (click)="acceptCode()">
            <i class="fas fa-check"></i>
            <span>Apply Code</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>